'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index.js');

var _styles = require('../helpers/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseResource = function (_React$Component) {
  _inherits(BaseResource, _React$Component);

  function BaseResource() {
    _classCallCheck(this, BaseResource);

    return _possibleConstructorReturn(this, (BaseResource.__proto__ || Object.getPrototypeOf(BaseResource)).apply(this, arguments));
  }

  _createClass(BaseResource, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.state = {};
    }
  }, {
    key: 'render',
    value: function render() {
      var baseResource = this.props.baseResource;
      var html = [];
      if (baseResource.iFrameResource) {
        baseResource.iFrameResource.forEach(function (resource, index) {
          var iFrameResource = _react2.default.createElement(_index.IFrameResource, {
            resource: resource,
            key: 'iframe-companion-' + index
          });
          html.push(iFrameResource);
        });
      }

      if (baseResource.staticResource) {
        baseResource.staticResource.forEach(function (resource, index) {
          var staticResource = _react2.default.createElement(_index.StaticResource, {
            resource: resource,
            key: 'static-companion-' + index
          });
          html.push(staticResource);
        });
      }

      if (baseResource.htmlResource) {
        baseResource.htmlResource.forEach(function (resource, index) {
          var htmlResource = _react2.default.createElement(_index.HtmlResource, {
            resource: resource,
            key: 'html-companion-' + index
          });
          html.push(htmlResource);
        });
      }

      var divStyle = _extends({
        height: this.props.height + 'px',
        width: this.props.width + 'px'
      }, _styles.vastBaseStyle);

      return _react2.default.createElement(
        'div',
        { style: divStyle },
        html
      );
    }
  }]);

  return BaseResource;
}(_react2.default.Component);

BaseResource.propTypes = {
  baseResource: _react2.default.PropTypes.object.isRequired,
  height: _react2.default.PropTypes.number.isRequired,
  width: _react2.default.PropTypes.number.isRequired
};

exports.default = BaseResource;
//# sourceMappingURL=base-resource.js.map


// WEBPACK FOOTER //
// ./src/resources/base-resource.js